$(function () {
    initValidation();

    $('#frm').on("submit", function (e) {
        var tabInt = parseInt($('#tab').val());
        if (tabInt === 5 && partCounter === 1) {
            e.preventDefault();
            $('#SparePartNumberInput').closest('.fieldGroup').addClass('error');
        }
    });

    $("#SparePartNumberInput").typeaheadSearch();

    //datepicker
    $("#MachineRepairDate").datepicker({
        inline: true,
        firstDay: 1,
        dateFormat: 'dd-mm-yy'
    }).datepicker().val($("#MachineRepairDate").val());

    $("#MachineDeliveryDate").datepicker({
        inline: true,
        firstDay: 1,
        dateFormat: 'dd-mm-yy'
    }).datepicker().val($("#MachineDeliveryDate").val());
    // Hover states on the static widgets
    $("#dialog-link, #icons li").hover(
        function () {
            $(this).addClass("ui-state-hover");
        },
        function () {
            $(this).removeClass("ui-state-hover");
        }
        );


    $("body").on("click", ".deleteBtn", function () {
        var winWidth = window.innerWidth;
        var comfirmWindow = $('.js-comfirm-window').attr('data-translate-comfirm-window');

        if (confirm(comfirmWindow) == true) {
            if (winWidth < 480) {
                console.log('slet');
                $(this).closest(".added-parts-container").remove();
            }
            else {
                $(this).closest("tr").remove();
            }
        }
    });


    //  Tab 5  //
    $("#searchSparePartButton").on("click", function () {
        var sparePartNumber = $("#SparePartNumberInput").val();
        if (sparePartNumber.indexOf(":") > -1) {
            sparePartNumber = sparePartNumber.substring(0, sparePartNumber.indexOf(":"));
        }
        sparePartNumber = sparePartNumber.replace('.', '_');
        var machineType = $("#MachineType").val();

        $.getJSON("/Base/ClaimReportServices/SearchSpareParts/" + machineType + "/" + sparePartNumber + "/" + twoLetterIsoLanguageName, function (data) {
            if (data.Valid) {
                AddPart(data.PartNumber, data.Name, 0);
                $('#SparePartNumberInput').data('required', 'false');
            } else {
                alert($("#searchSparePartButton").attr("data-message"));
            }

        });
        $("#SparePartNumberInput").val('');
    });


    //  Tab 1  //
    $("#searchSerialButton").on("click", function () {
        var MachineSerialSearchInput = $("#MachineSerialSearch");
        MachineSerialSearchInput = MachineSerialSearchInput.val().replace('.', '_');
        $.getJSON("/Base/ClaimReportServices/CheckSerialNumber/" + MachineSerialSearchInput, function (data) {
            if (data.Valid) {
                $("#createReportButton").show();
                $("#MachineSerialSearch").removeClass('invalid');
                $("#MachineSerialSearch").addClass('valid');
                $('.validationMessage').removeClass('show-validation-message');
                $('.tab__field-label').removeClass('invalid-label');

            } else {
                $("#createReportButton").hide();
                $("#MachineSerialSearch").removeClass('valid');
                $("#MachineSerialSearch").addClass('invalid');

                $('.validationMessage').addClass('show-validation-message');
                $('.tab__field-label').addClass('invalid-label');
            }
        });
    });
    $("#createReportButton").on("click", function () {
        var MachineSerialSearchInput = $("#MachineSerialSearch");
        MachineSerialSearchInput = MachineSerialSearchInput.val().replace('.', '_');
        $.getJSON("/Base/ClaimReportServices/CheckSerialNumber/" + MachineSerialSearchInput, function (data) {
            if (data.Valid) {
                $("#MachineSerial").val(data.SerialNumber);
                $("#MachineType").val(data.MachineType);
                $("#frm").show();
                $("#searchSerialDiv").hide();
            } else {
                $("#createReportButton").hide();
                $("#MachineSerialSearch").removeClass('valid');
                $("#MachineSerialSearch").addClass('invalid');
            }
        });
    });

});



window.onload = function () {
    if ($('#executeJsOnLoad').val() == 1) {
        $('#frm').submit();
    }
}





//  Tab 4  //
function GetClaimFile(fileIdFromClaim) {
    window.location = '/uservice/GetClaimFile.ashx?fileId=' + fileIdFromClaim;
}

function AddLine() {
    partCounter++;
    var html = '<div>' +
    '<input type="file" multiple="true" name="part$' + partCounter + '$File" />' +
    '</div>';
    $("#divItemContainer").append(html);
}

function AddPart(partId, description, qty) {
    var winWidth = window.innerWidth;

    var validationDescription = $('.js-parts-list').attr('data-translate-description-validation');
    var validationNumber = $('.js-parts-list').attr('data-translate-no-validation');

    var html = '<tr>' +
    '<td><div class="fieldGroup"><input type="hidden" class="col1" name="part$' + partCounter + '$Id" />' +
    '<input class="input default" readonly="readonly" type="text" style="width: 90%; margin-right: 4px;" name="part$' + partCounter + '$PartId" value="' + partId + '" /></div></td>' +
    '<td><div class="fieldGroup"><input class="input default tab5-validation col2" type="text" required name="part$' + partCounter + '$Description" value="' + description + '" style="width: 90%; margin-right: 4px;" /><span class="validationMessage validationMessageDescription">' + validationDescription + '</span></div></td>' +
    '<td><div class="fieldGroup"><input class="input default tab5-validation col3" type="text" name="part$' + partCounter + '$Quantity" value="' + qty + '" style="width: 90%; margin-right: 4px;" required pattern="^[1-9]+[0-9]*$" /><span class="validationMessage validationMessageNumber">' + validationNumber + '</span></div></td>' +
    '<td><div class="claimreport__delete"><button class="deleteBtn" type="button"><svg class="claimreport__delete--icon claimreport__delete--tab5"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/dist/icons/icons.svg#close"></use></svg></button></div></td>' +
    '</tr>';

    var partNumber = $('.js-parts-list').attr('data-translate-article');
    var partDescription = $('.js-parts-list').attr('data-translate-description');
    var partQuantity = $('.js-parts-list').attr('data-translate-no');

    var htmlMobile = '<div class="added-parts-container">' +
    '<div class="fieldGroup"><input type="hidden" class="col1" name="part$' + partCounter + '$Id" />' +
    '<div class="col--sm-12 no-gutter-tab"><div class="claimreport__delete"><button class="deleteBtn" type="button"><svg class="claimreport__delete--icon claimreport__delete--tab5"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/dist/icons/icons.svg#close"></use></svg></button></div></div>' +
    '<div class="col--sm-12 no-gutter-tab"><div>' + partNumber + '</div><div class="fieldGroup"><input class="input default" readonly="readonly" type="text" style="width: 90%; margin-right: 4px;" name="part$' + partCounter + '$PartId" value="' + partId + '" /></div></div></div>' +
    '<div class="col--sm-12 no-gutter-tab"><div>' + partDescription + '</div><div class="fieldGroup"><input class="input default tab5-validation col2" type="text" required name="part$' + partCounter + '$Description" value="' + description + '" style="width: 90%; margin-right: 4px;" /><span class="validationMessage validationMessageDescription">' + validationDescription + '</span></div></div>' +
    '<div class="col--sm-12 no-gutter-tab"><div>' + partQuantity + '</div><div class="fieldGroup"><input class="input default tab5-validation col3" type="text" name="part$' + partCounter + '$Quantity" value="' + qty + '" style="width: 90%; margin-right: 4px;" required pattern="^[1-9]+[0-9]*$" /><span class="validationMessage validationMessageNumber">' + validationNumber + '</span></div></div>' +
    '<div class="hr col--md-12 no-gutter-tab"></div>' +
    '</div>';

    if (winWidth < 480) {
        $("#tablePartsContainerMobile").append(htmlMobile);
    }
    else {
        $("#tablePartsContainer").append(html);
    }
    //$('#frm').validateDestroy();
    initValidation();
    partCounter++;
}







/*function next() {
    console.log("Next");
    var tabInt = parseInt($('#tab').val());
    $('#tab').val(tabInt + 1);
}*/

var claimHaschanged = false;
function setClaimChanged() {
    claimHaschanged = true;
}
function unlockClaimChanged() {
    console.log('js')
    claimHaschanged = false;
}



function validateDate() {
    console.log('validate date');
    var $delivery = $('#MachineDeliveryDate');
    var $repair = $('#MachineRepairDate');

    var repairDateObject = $repair.val().split('-');
    var repairDate = new Date();
    repairDate.setFullYear(repairDateObject[2], repairDateObject[1] - 1, repairDateObject[0]);

    var deliveryDateObject = $delivery.val().split('-');
    var deliveryDate = new Date();
    deliveryDate.setFullYear(deliveryDateObject[2], deliveryDateObject[1] - 1, deliveryDateObject[0]);

    if (deliveryDate > repairDate) {


        // $repair.parents('.fieldGroup').addClass('custom-error');
        $delivery.parents('.fieldGroup').addClass('custom-error');

        $delivery.siblings('.validationMessage').html($("#tab-2").attr(data - message));
        // $repair.siblings('.validationMessage').html('Leveringsdato skal være før end reparationsdato');

        return false;

    }

}

//function validateTextarea() {
//    console.log('validate textarea');

//    var $textarea = $('textarea.textarea');
//    var isValid = true;


//    $textarea.each(function() {
//        var $this = $(this);

//        if ($this.val().length < 20) {
//            console.log('validate textarea 2');
//            $this.closest('.fieldGroup').addClass('error');

//            isValid = false; 
//        }

//    });

//    return isValid;
//}




function initValidation() {
    $('#frm')
        .validate({
            onKeyup: true,
            onClick: true,
            onChange: true,
            showErrors: function (errorMap, errorList) {
                for (var i = 0; i < this.errorList.length; i++) {
                    $(this.errorList[i].element).closest('.fieldGroup').addClass('error');
                }

                for (var i = 0; i < this.successList.length; i++) {
                    $(this.successList[i]).closest('.fieldGroup').removeClass('error');
                }
            }
        });

}